import { useTranslation } from '@klv/hooks/useTranslation';

import Button from '@klv/atoms/button';

import * as s from './styles/skipButton.module.scss';

import type { IButtonProps } from '../button/types';

const SkipButton = ({
  buttonColor = 'dark',
  id = 'skip-button',
  text = 'Skip to main content',
  url = '#site-content',
  variant = 'ghost',
}: IButtonProps) => {
  const { t } = useTranslation();
  const  translatedText = `${t('atoms_skipButton_skipContent')}` || text;
  
  return (
  <Button
    buttonColor={buttonColor}
    className={s.skipButton}
    id={id}
    text={translatedText}
    url={url}
    variant={variant}
  />
  );
};

export default SkipButton;
